<template>
    <v-container class="sidebar-content configurable-tour-sidebar">
        <div
            ref="options"
            v-if="data.configurationOptions"
        >
            <Rooms
                v-if="data.configurationOptions"
                :rooms="data.configurationOptions"
                :showRoomsMenu="showRoomsMenu"
                @select-room="selectRoom"
                @toggle-rooms-menu ="toggleRoomsMenu"
            />

            <RoomItems
                v-if="data.configurationOptions[activatedRoom].items && data.materials"
                v-show="data.configurationOptions[activatedRoom].items && data.configurationOptions[activatedRoom].hasCombination"
                :isLoaded="isRoomItemLoaded"
                :roomItems="data.configurationOptions[activatedRoom].items"
                :materials="data.materials"
                @toggle-rooms-menu ="toggleRoomsMenu"
            />
        </div>
    </v-container>
</template>

<script>
    import { EventBus } from '@/event-bus';
    import Rooms from '@/layout/sidebar/configurableTour/components/Rooms';
    import RoomItems from '@/layout/sidebar/configurableTour/components/RoomItems';

    export default {
        name: 'ConfigurableTourSidebar',
        components: {
            Rooms,
            RoomItems
        },
        props: [
            'data',
            'handler'
        ],
        data: () => ({
            activatedRoom: 0,
            isLoadingScene: false,
            showRoomsMenu: true
        }),
        computed: {
            isRoomItemLoaded() {
                return !this.isLoadingScene ? true : false;
            }
        },
        mounted() {
            this.handler();
            this.activatedRoom = this.$props.data.configurationOptions.findIndex(options => options.hasCombination === true);
            this.$props.data.configurationOptions[this.activatedRoom].active = true;

            EventBus.$emit('loadRoom', this.activatedRoom);
            EventBus.$on('sceneLoaded', () => {
                this.isLoadingScene = false;
            });

            EventBus.$on('updateSelectedRoom', room => {
                this.selectRoom(room);
            });
        },
        methods: {
            selectRoom(newRoom) {
                if (newRoom) {
                    if (!this.isLoadingScene) {
                        this.data.configurationOptions.forEach(configuration => configuration.active = false);
                        this.data.configurationOptions.find(room => room.name === newRoom.name).active = true;
                        this.activatedRoom = this.data.configurationOptions.findIndex(configuration => configuration.active);
                    }
                }
            },
            toggleRoomsMenu(val=false) {
                this.showRoomsMenu = val;
            }
        },
        watch: {
            activatedRoom() {
                this.isLoadingScene = true;
                EventBus.$emit('loadRoom', this.activatedRoom);
            }
        }
    }
</script>

<style lang="scss">
    @import "@/assets/scss/components/_configurable-tour_sidebar.scss";
</style>


// WEBPACK FOOTER //
// src/layout/sidebar/configurableTour/ConfigurableTourSidebar.vue